var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"input textarea"},[_c('span',[_vm._v(_vm._s(_vm.prependLabel))]),_c('v-textarea',_vm._b({ref:"input",class:{ filled: !!_vm.value },attrs:{"value":_vm.value,"outlined":""},on:{"input":_vm.update,"keypress":_vm.keypress}},'v-textarea',{..._vm.$props, ..._vm.$attrs},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }